export const language: any = {
  add_by_image: "เพิ่มจากรูปภาพ",
  add_image_by_camera: "ถ่ายรูปด้วยกล้อง",
  add_image_by_gallery: "เลือกจากแกลเลอรี",
  loading: "กำลังเตรียมสูตรอร่อย ๆ กรุณารอสักครู่",
  retry: "ลองใหม่",
  cancel: "ยกเลิก",
  yes: "ใช่",
  no: "ไม่",
  goToIngredient: "วิเคราะห์ส่วนผสม",
  goToRecipe: "วิเคราะห์สูตร",
  recipe: {
    title: "สูตร AI",
    analysis_results: "ผลการวิเคราะห์",
    ingredients: {
      title: "ส่วนผสม (1 ที่)",
      view_more: "ดูส่วนผสมเพิ่มอีก {number} รายการ",
      view_less: "ย่อ",
    },
    how_to_cook: "วิธีการทำอาหาร",
    go_to_detail: "ดูสูตร AI",
    description: "คำแนะนำเกี่ยวกับสูตรอาหาร",
    calories: "แคลอรี่",
    time: "เวลาปรุงอาหาร",
    ingredient: "ส่วนประกอบหลัก",
    spice: "เครื่องปรุง",
    tip: "TIP",
  },
  ingredient: {
    title: "การวิเคราะห์ภาพ",
    analysis_results: "ผลการวิเคราะห์จากภาพแสดงส่วนผสมดังนี้",
    add_to_cart: "เพิ่มลงในตะกร้า",
    add_to_my_ingredients: "เพิ่มส่วนผสม",
  },
  msg: {
    not_ingredients: `นี่เป็นภาพที่สวยงามค่ะ\nแต่ที่นี่สำหรับวัตถุดิบเท่านั้น!\nครั้งหน้า โปรดถ่ายภาพวัตถุดิบอร่อย ๆ มาให้นะคะ\nความลับของการทำอาหารกำลังรอคุณอยู่!\nจะย้ายไปที่ AI Chef ไหม?`,
    // AC-01-MSG-01
    not_recipes: `อืม นี่ไม่ใช่การทำอาหาร\nเราสามารถวิเคราะห์ได้แค่ภาพอาหาร\nกรุณาอัพโหลดภาพอาหารที่เสร็จสมบูรณ์\nต้องการไปที่การวิเคราะห์ส่วนผสมไหม?`,
    not_found: "ไม่พบข้อมูล",
    unknow: `ดูเหมือนว่านี่จะไม่ใช่ภาพของอาหารหรือวัตถุดิบ\nหากคุณอัปโหลดภาพอาหารหรือวัตถุดิบเพื่อการวิเคราะห์\nเราจะสามารถช่วยคุณได้ดียิ่งขึ้น!`,
    upload_fail: `การอัปโหลดล้มเหลวเนื่องจากข้อผิดพลาดชั่วคราว\nกรุณาลองอีกครั้งในภายหลัง`,
    error: `โอ๊ะ! การวิเคราะห์ภาพล้มเหลว\nกรุณาเลือกภาพใหม่ หรือ\nลองใช้ภาพที่ชัดเจนกว่านี้ดูไหม?`,
    bothType: `ในภาพนี้มีทั้งส่วนผสมและอาหาร!\nกรุณาเลือกว่าจะวิเคราะห์อะไรจากภาพนี้`,
  },
}
